import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import BlockIcon from '@mui/icons-material/Block';
import { ReactComponent as DeleteIcon } from '../../../../../../assets/delete-red.svg';
import zeplinColor from '../../../../../../theme/Color';

interface FloatingActionBarProps {
  selectedCount: number;
  onClearSelection: () => void;
  onChangeRole: () => void;
  onUnblock: () => void;
  onBlock: () => void;
  onDelete: () => void;
}

const FloatingActionBar: React.FC<FloatingActionBarProps> = ({
  selectedCount,
  onClearSelection,
  onChangeRole,
  onUnblock,
  onBlock,
  onDelete,
}) => {
  if (selectedCount === 0) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: '2rem',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: zeplinColor.BasicBlack,
        borderRadius: '16px',
        padding: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: '80px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        zIndex: 10,
      }}
    >
      <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <IconButton
          onClick={onClearSelection}
          sx={{
            padding: '0px',
            color: zeplinColor.Neutral1,
            '&:hover': {
              color: zeplinColor.Neutral1,
            },
          }}
          title='Clear Selection'
        >
          <CloseIcon sx={{ fontSize: 20 }} />
        </IconButton>
        <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
          {selectedCount} selected
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 12px',
            borderRadius: '8px',
            height: '32px',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: zeplinColor.Neutral10,
            },
          }}
          onClick={onChangeRole}
        >
          <PersonOutlineIcon sx={{ fontSize: 20, color: zeplinColor.Neutral1 }} />
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
            Change Role
          </Typography>
        </Box>

        <Box
          sx={{
            height: '16px',
            width: '1px',
            backgroundColor: zeplinColor.Neutral5,
          }}
        />

        {/* Unblock */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 12px',
            borderRadius: '8px',
            height: '32px',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: zeplinColor.Neutral10,
            },
          }}
          onClick={onUnblock}
        >
          <CheckCircleOutlineIcon sx={{ fontSize: 20, color: zeplinColor.Neutral1 }} />
          <Typography variant='body3' color={zeplinColor.Neutral1}>
            Unblock
          </Typography>
        </Box>

        <Box
          sx={{
            height: '16px',
            width: '1px',
            backgroundColor: zeplinColor.Neutral5,
          }}
        />

        {/* Block */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 12px',
            borderRadius: '8px',
            height: '32px',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: zeplinColor.Neutral10,
            },
          }}
          onClick={onBlock}
        >
          <BlockIcon sx={{ fontSize: 20, color: zeplinColor.Neutral1 }} />
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
            Block
          </Typography>
        </Box>

        <Box
          sx={{
            height: '16px',
            width: '1px',
            backgroundColor: zeplinColor.Neutral5,
          }}
        />

        {/* Delete */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 12px',
            borderRadius: '8px',
            height: '32px',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: zeplinColor.Neutral10,
            },
          }}
          onClick={onDelete}
        >
          <DeleteIcon style={{ width: 20, height: 20, color: zeplinColor.Neutral1 }} />
          <Typography variant='responsiveBody3' color={zeplinColor.Error}>
            Delete
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default FloatingActionBar;
